import { defineComponent as _defineComponent } from 'vue'
import CalendarPicker from './calendar-picker.vue'
import { ref, computed } from 'vue'
import { CalendarEvents } from '@busy-human/k9-library';
import { useCalendarEvents } from '@/store/calendarEvents'
import { useUserspace } from '@/store/useUsers';
import { DataInstance } from '@busy-human/gearbox'

type Props = {
    selectedEvent: DataInstance<CalendarEvents.Model>
}

type Emits = {
    (e: 'close'): void
}
enum SetupStage {
    CONTACT = 1,  
    TYPE = 2,
    DATE = 3,
}

namespace SetupStage {
    export function before(value: SetupStage): SetupStage{
        if(Object.values(SetupStage).some((v)=>v === value-1))
            return value - 1
        else
            return value
    }
    export function after(value: SetupStage): SetupStage{
        if(Object.values(SetupStage).some((v)=>v === value+1))
            return value + 1
        else
            return value
    }
}
enum DogSelectType {
    REGISTER = 1,
    EXISTING = 2,
}

// User Inputs

export default /*@__PURE__*/_defineComponent({
  __name: 'event-modal',
  props: {
    selectedEvent: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

// import TimeslotPicker from './timeslot-picker.vue'
const calendarEvents = useCalendarEvents();
const userspaces = useUserspace();

const props = __props

const emit = __emit;

let mode = ref(SetupStage.CONTACT)

const startDateTime = ref<string | null>(null)
const endDateTime = ref<string | null>(null)

const eventUser = computed(() => {
    if(props.selectedEvent.userId)
        return userspaces.users[props.selectedEvent.userId]
})

const disableContinue = computed(() => {
    let disable = false;

    return disable
})

const progressStage = () => {
    if(mode.value === SetupStage.DATE){
        updateTrainingRequest()
    }else
        mode.value = SetupStage.after(mode.value)
}

const updateTrainingRequest = async () => {
    let tmp = {...props.selectedEvent}

    tmp.startTime = startDateTime.value!
    tmp.endTime = endDateTime.value!
    tmp.eventType = CalendarEvents.EventType.Training
    //TODO: Record the type of training method they're using on the calendarevent object

    await calendarEvents.updateCalendarEvent(tmp)
    emit('close')
}

const deleteRequest = async () => {
    await calendarEvents.deleteCalendarEvent(props.selectedEvent.$id)
    emit('close')
}


const __returned__ = { calendarEvents, userspaces, props, emit, SetupStage, get mode() { return mode }, set mode(v) { mode = v }, DogSelectType, startDateTime, endDateTime, eventUser, disableContinue, progressStage, updateTrainingRequest, deleteRequest, CalendarPicker, ref, computed, get CalendarEvents() { return CalendarEvents }, get useCalendarEvents() { return useCalendarEvents }, get useUserspace() { return useUserspace }, get DataInstance() { return DataInstance } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})